import { buildModelManager } from "../builder.js";
const DefaultSendTemplateQueueSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  isSent: true,
  request: true,
  sendingDate: true,
  updatedAt: true
};
const modelApiIdentifier = "sendTemplateQueue";
const pluralModelApiIdentifier = "sendTemplateQueues";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSendTemplateQueueSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSendTemplateQueue",
    operationReturnType: "CreateSendTemplateQueue",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      sendTemplateQueue: { required: false, type: "CreateSendTemplateQueueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSendTemplateQueues",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSendTemplateQueuesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "action",
    operationName: "updateSendTemplateQueue",
    operationReturnType: "UpdateSendTemplateQueue",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      sendTemplateQueue: { required: false, type: "UpdateSendTemplateQueueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateSendTemplateQueues",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateSendTemplateQueuesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "action",
    operationName: "deleteSendTemplateQueue",
    operationReturnType: "DeleteSendTemplateQueue",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteSendTemplateQueues",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertSendTemplateQueue",
    operationReturnType: "UpsertSendTemplateQueue",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      sendTemplateQueue: { required: false, type: "UpsertSendTemplateQueueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateSendTemplateQueueResult": { hasReturnType: false },
      "... on UpdateSendTemplateQueueResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertSendTemplateQueues",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertSendTemplateQueuesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultSendTemplateQueueSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "sendTemplateQueueGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const SendTemplateQueueManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSendTemplateQueueSelection,
  operations
);
export {
  DefaultSendTemplateQueueSelection,
  SendTemplateQueueManager
};
//# sourceMappingURL=SendTemplateQueue.js.map
